import React from "react";
import { PivCard } from "./election-piv-card";

export const PivGrid = ({ data }: any) => {
    const sortedPiv = Object.entries(data || {}).sort(
        ([a], [b]) => a.localeCompare(b) // 🔥 alphabetical sort
    );

    return (
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
            {sortedPiv.map(([key, val]) => (
                <PivCard key={key} name={key} data={val} />
            ))}
        </div>
    );
};
